import { render } from "./PagePanel.vue?vue&type=template&id=2f6b26a0&scoped=true"
const script = {}

import "./PagePanel.vue?vue&type=style&index=0&id=2f6b26a0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6b26a0"]])

export default __exports__